import { useState, useEffect } from 'react';
import { differenceInDays, formatDistanceStrict, format } from 'date-fns';
import formatTime from '@sdk/utils/dateFormat/formatTime';
import { useSession } from '@sdk/session/SessionContext';
import gettext from '@sdk/lang/gettext';
import { DisplayTextProps } from '@sdk/components/ui/DisplayTextStyle';
import DisplayText from '@sdk/components//ui/DisplayText';

type Props = {
  date: Date;
} & DisplayTextProps;

export const RelativeDateString = ({ date, ...textProps }: Props) => {
  const [showRelativeDate, setShowRelativeDate] = useState(false);
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    let intervalId;
    if (showRelativeDate) {
      intervalId = setInterval(() => {
        setNow(new Date());
      }, 1000);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [showRelativeDate]);

  useEffect(() => {
    const daysSincePosted = differenceInDays(now, date);
    setShowRelativeDate(daysSincePosted < 2);
  }, [now, date]);

  const { currentUser } = useSession();
  const formattedDate = showRelativeDate
    ? formatDistanceStrict(date, now, { addSuffix: true })
    : format(date, 'dd MMM yyyy');
  const formattedTime = formatTime(date, currentUser.settings.usTimeFormat);

  const title = gettext('%(date)s at %(time)s', { date: formattedDate, time: formattedTime });

  return <DisplayText {...textProps}>{title}</DisplayText>;
};
